import { render, staticRenderFns } from "./ShowBanMemM.vue?vue&type=template&id=1c6bef7c&scoped=true&"
import script from "./ShowBanMemM.vue?vue&type=script&lang=js&"
export * from "./ShowBanMemM.vue?vue&type=script&lang=js&"
import style0 from "./ShowBanMemM.vue?vue&type=style&index=0&id=1c6bef7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bef7c",
  null
  
)

component.options.__file = "ShowBanMemM.vue"
export default component.exports